<ng-container *ngIf="showNothing"></ng-container>
<fa-icon
  *ngIf="showPurpleDot"
  [icon]="circle"
  size="xs"
  class="ViewRepresentativesStatus-purple"
  [title]="purpleDotTooltip"
></fa-icon>
<span *ngIf="showDogIcon" [title]="dogIconTooltip" class="ViewRepresentativesStatus-dog-wrapper">
  <app-svg-renderer
    [svg]="'Dog Icon'"
    class="ViewRepresentativesStatus-dog"
  ></app-svg-renderer>
</span>
<fa-icon
  *ngIf="showOldStatus && account?.status"
  [icon]="circle"
  size="xs"
  class="EmailStatus-{{ account.status }}"
  [title]="oldStatusTooltip"
></fa-icon>
